<template>
<div class="search-bar">

  <!-- Search input -->
  <form @submit.prevent="search">
    <div class="search-elements-container">
      <input type="text"
              :placeholder="$t('search_input')"
              :value="$store.state.search.searchQuery"
              @input="updateSearchQuery">
      <button type="submit" class="search-button-large btn btn-search btn-primary btn-lg">
          <font-awesome-icon v-if="$store.state.search.loadingSearch" class="spinner" icon="spinner" spin></font-awesome-icon>
          <span v-else>{{$t('search_submit')}}</span>
      </button>
      <button type="submit" class="search-button-small btn btn-search btn-primary btn-lg">
          <font-awesome-icon v-if="$store.state.search.loadingSearch" class="spinner" icon="spinner" spin></font-awesome-icon>
          <font-awesome-icon v-else icon="search"></font-awesome-icon>
      </button>
    </div>
  </form>
  
  <!-- Suggestions box -->
  <div class="quicksearch" v-show="quickSearchResultsOpen" ref="suggestions">
    <ul>
      <li v-for="(result, index) in quickSearchResults" :key="index">
        <a href="#" @click="applyQuickSearch(result)">
          {{result.type === 'lamp' ? result.material_description : result.product_description}}
        </a>
      </li>
    </ul>
  </div>

</div>
</template>

<script>
  import Vue from 'vue';
  import { http } from '@/services/http';
  import { debounce } from 'lodash';

  export default {
    data() {
      return {
        quickSearchResults: [],
        quickSearchResultsOpen: false
      }
    },
    methods: {
      search() {
        // Prevent double actions
        if (this.$store.state.search.loadingSearch)
          return;

        this.$emit("search");
        this.$store.commit('search/searchedQuery', this.$store.state.search.searchQuery);
        this.$store.dispatch('search/search').then(results => {
          this.$store.state.search.loading = '';
          let searchResults = "true";
          if(results.length === 0) {
            searchResults = "false";
            this.$snotify.error(this.$t("no_results_found"));
          }
          try {
            omniture.trackSearch(this.$store.state.search.searchQuery, searchResults);
          } catch (e) {}
        });
      },
      updateSearchQuery(e) {
        this.$store.commit('search/searchQuery', e.target.value);
        
        const query = encodeURIComponent(e.target.value);
        if(query.length > 3) {
          this.debounceSearch(query);
        } else {
          this.quickSearchResults = [];
        }
      },
      debounceSearch: debounce(function(query) {
        let lamp_driver_type = this.$store.state.search.alternative === "conventional" ? 'Conventional' : 'LED';
        const country = lamp_driver_type === 'Conventional' ? 'global' : this.$store.state.search.country;
        const vendor = this.$store.state.search.vendor;
        http.post(`/search/${lamp_driver_type}/${vendor}/${country}/?q=${query}`, {
          facets: this.$store.state.search.availableFacets,
          filters: {
            all: this.$store.state.search.filters
          }
        }).then(response => {
          if (response.data.results.length) {
            this.quickSearchResults = response.data.results;
          } else {
            this.quickSearchResults = [];
          }
        })
      }, 400),

      applyQuickSearch(result) {
        const query = result.type === 'lamp' ? result.material_description : result.product_description;
        this.$store.commit('search/searchQuery', query)
        this.search();
        this.quickSearchResults = [];
      },

      closeClickHandler(event) {
        if (!this.$refs.suggestions.contains(event.target)) {
          this.quickSearchResultsOpen = false;
          window.removeEventListener('click', this.closeClickHandler);
        }
      },
    },
    watch: {
      quickSearchResults(newValue) {
        if(newValue.length > 3) {
          this.quickSearchResultsOpen = true;
          Vue.nextTick().then(() => {
            window.addEventListener('click', this.closeClickHandler);
          });
        } else {
          this.quickSearchResultsOpen = false;
        }
      }
    }
  };
</script>

<style lang="scss">

  .quicksearch {
    border: 1px solid #b9b9b9;
    border-radius: $border-radius;
    background: white;
    position: absolute;
    z-index: 2;
    padding: 10px;
    margin-top: 5px;

    ul {
      padding: 0;
      margin: 0;
      list-style-type: none;
    }
    li {
      padding: 3px 0;
    }
  }

  .search-elements-container {
    display: flex;

    // Search bar
    input {
        flex: 1;
        box-sizing: border-box;
        font-size: $nc-fsz-normal;
        line-height: 19px;
        padding: 0 16px;
        color: #545454;
        border: $nc-gray-border;
    }
    input::placeholder {
        color: #545454;
    }

    .btn {
        margin-left: 20px;
        font-size: $nc-fsz-normal;
        border-radius: 3px;
    }

    .btn-search {
        margin-top: 0;
        width: 140px;

        &.search-button-small {
          width: 40px;
        }
    }

    .spinner {
        color: $white;
    }

    .search-button-small {
        @include media-breakpoint-up(md) {
          display: none;
        }
    }

    .search-button-large {
        @include media-breakpoint-down(sm) {
          display: none;
        }
    }
  }
</style>
